import { PriceCheck } from '@mui/icons-material';
import Page from 'components/new/Page';
import ErrorBoundary from 'components/ErrorBoundary';
import { RolePermission } from 'further-types/admin-user-role';
import TabsPanel from 'further-ui/components/TabsPanel';
import PageLoader from 'components/PageLoader';

import ChartOfAccounts from './ChartOfAccounts';
import FundSetup from './FundSetup';
import AccountMapping from './AccountMapping';
import FeeSettings from './FeeSettings';
import CarrySettings from './CarrySettings';
import EqualisationInterest from './EqualisationInterest';
import { useGetAllPermissionsList } from 'hooks/ui/usePermissions';

const tabs = [
  {
    key: 'general',
    label: 'General',
    content: <FundSetup />,
    urlParam: 'general',
    permission: RolePermission.LpEditVehicle,
  },
  /*
  Uncoment when features are ready
  {
    key: 'approvalFlows',
    label: 'Approval Flows',
    content: <ApprovalFlows />,
    urlParam: 'approvalFlows',
  },
  */
  {
    key: 'chartOfAccounts',
    label: 'Chart of accounts',
    content: <ChartOfAccounts />,
    urlParam: 'chartOfAccounts',
    permission: RolePermission.LpCreateAccount,
  },
  {
    key: 'accountMapping',
    label: 'Account mapping',
    content: <AccountMapping />,
    urlParam: 'accountMapping',
    permission: RolePermission.LpCreateAccount,
  },
  {
    key: 'feeSettings',
    label: 'Fee settings',
    content: <FeeSettings />,
    urlParam: 'feeSettings',
    permission: RolePermission.LpEditVehicle,
  },
  {
    key: 'carrySettings',
    label: 'Carry settings',
    content: <CarrySettings />,
    urlParam: 'carrySettings',
    permission: RolePermission.LpEditVehicle,
  },
  {
    key: 'equalisationInterest',
    label: 'Equalisation interest',
    content: <EqualisationInterest />,
    urlParam: 'equalisationInterest',
    permission: RolePermission.LpEditVehicle,
  },
];

const FundSetupPage: React.FC = () => {
  const permissionsList = useGetAllPermissionsList();

  const permissionFilter = (requiredPermission: RolePermission) => {
    return permissionsList?.includes(requiredPermission);
  };

  return (
    <Page
      tabTitle="Fund Setup"
      heading="Fund Setup"
      headingIcon={PriceCheck}
      spacing="sm"
    >
      <ErrorBoundary loader={<PageLoader />}>
        <TabsPanel
          useTabsUrls
          tabs={tabs.filter((tab) => permissionFilter(tab.permission))}
        />
      </ErrorBoundary>
    </Page>
  );
};

export default FundSetupPage;
